import { Map } from 'immutable';
import { createSelector } from 'reselect';

const selectNotify = (state) => state.get('notify', Map());

const makeSelectIsNotifyOpen = () => createSelector(selectNotify, (state) => state.get('isOpen'));

const makeSelectNotifyOptions = () => createSelector(selectNotify, (state) => state.get('options'));

export { selectNotify, makeSelectIsNotifyOpen, makeSelectNotifyOptions };
